"use client";

import { useEffect, useState } from "react";
import AuthRequiredContent from "./AuthRequiredContent";

interface Props {
  title?: string;
  description?: string;
  continueHref?: string;
  onContinueClick?: () => void;
}

const AuthRequiredSheet = ({ title, description, continueHref, onContinueClick }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // RAF ile bir sonraki frame'de visible=true → CSS transition tetiklenir
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      className="fixed left-0 right-0 bottom-0 z-[9991] bg-white rounded-t-2xl pb-safe shadow-2xl max-h-[85vh] overflow-hidden"
      style={{
        transform: visible ? "translateY(0)" : "translateY(110%)",
        transition: "transform 0.35s cubic-bezier(0.2, 0, 0, 1)",
      }}
    >
      <div className="flex justify-center pt-3 pb-1">
        <div className="w-10 h-1 rounded-full bg-gray-300" />
      </div>

      <AuthRequiredContent title={title} description={description} continueHref={continueHref} onContinueClick={onContinueClick} />
    </div>
  );
};

export default AuthRequiredSheet;